import { __spreadArray, __read } from 'tslib';

/**
 * usePagination
 * provide helper framework for building a headless pagination
 * inspired by the design pattern from MUI
 * https://material-ui.com/components/pagination/#usepagination
 * @material-ui/lab/Pagination
 */
var checkIsEllipsis = function (p, i, pages, length) {
    if ((i === 1 && p !== 2) || (i === length - 2 && p !== pages - 1)) {
        return true;
    }
    return false;
};
var usePagination = function (_a) {
    var pages = _a.pages, _b = _a.length, length = _b === void 0 ? 7 : _b, _c = _a.page, page = _c === void 0 ? 1 : _c, _d = _a.includePageRanges, includePageRangesArg = _d === void 0 ? true : _d;
    // only show ellipsis, first page and last page if length > 5.
    var includePageRanges = length >= 5 ? includePageRangesArg : false;
    // number of visible pages in the pagination.
    var realVisiblePages = length < pages ? length : pages;
    // check `page` has human error.
    var selectedPage = page;
    if (selectedPage < 1)
        selectedPage = 1;
    if (selectedPage > pages)
        selectedPage = pages;
    var startPage = Math.ceil(selectedPage - length / 2);
    if (startPage + length > pages) {
        startPage = pages - length + 1;
    }
    if (startPage < 1) {
        startPage = 1;
    }
    var pageArr = __spreadArray([], __read(Array(realVisiblePages)), false).map(function (e, i) { return i + startPage; });
    if (includePageRanges) {
        pageArr[0] = 1;
        pageArr[realVisiblePages - 1] = pages;
    }
    var items = pageArr.map(function (p, i) { return ({
        page: p,
        selected: p === selectedPage,
        type: includePageRanges && checkIsEllipsis(p, i, pages, realVisiblePages)
            ? "ellipsis"
            : "page",
    }); });
    return { items: items, selectedPage: selectedPage };
};

export { usePagination };
//# sourceMappingURL=usePagination.js.map
